module.exports = __webpack_public_path__ + "img/acceptance.1e753ed3.svg";